module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/ice-cream-2-4deab42b9fcc25dc1914398fe5b7eb24.svg";